/**
 * Share of the page the visitor has scrolled through, 0-100.
 *
 * Reads `body` alongside `documentElement` because the two disagree on which
 * owns `scrollTop` across browsers and quirks-mode documents.
 *
 * Returns 0 when the document does not scroll. A page shorter than the viewport
 * has no scrollable distance, and dividing by it yields NaN, which silently
 * fails every downstream `>=` comparison.
 */
export const getScrollPercent = (): number => {
  // Detects the browser at runtime; there is no value to parse at a boundary here.
  // oxlint-disable-next-line anti-slop/no-runtime-typeof
  if (typeof window === 'undefined') return 0;

  const html = document.documentElement;
  const scrollTop = html.scrollTop || document.body.scrollTop;
  const scrollableDistance = (html.scrollHeight || document.body.scrollHeight) - html.clientHeight;

  if (scrollableDistance <= 0) return 0;

  return Math.ceil((scrollTop / scrollableDistance) * 100);
};
